import * as React from 'react';
import { Icon } from 'antd';
import moment from 'moment';
import injectSheet from 'react-jss';
import { parseMention } from './utils';

const styles = theme => ({
  commentCard: {
    borderBottom: `1px solid ${theme.colors.border}`,
    width: '90%%',
    height: '100%',
    margin: '10px 0px 0px 15px',
    display: 'grid',
    gridGap: '0em 1em',
    gridTemplateRows: '20px 20px 1fr',
    gridTemplateColumns: '20px 20px 1fr',
    gridTemplateAreas: `
    'dot  mail  creation'
    '.    .     org'
    '.    .     content'
    `,
  },
  commentTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
  },
});

const Dot = () => {
  return <span style={{
    gridArea: 'dot',
    borderRadius: '14px',
    background: '#FFFFFF',
    border: 'solid 2px #1890FF',
  }}></span>;
};

const MailIcon = () => <Icon type="mail" style={{ margin: 'auto', gridArea: 'mail' }} />;

const User = ({
  user,
}) => {
  return user.name;
};
const Author = ({
  user,
}) => {
  return <span style={{
    fontWeight: 'bold',
    fontSize: '14px',
    marginRight: '10px',
  }}>
    <User user={user} />
  </span>;
};
const Timestamp = ({
  time,
}) => {
  return <span style={{
    color: '#888888',
    fontSize: '12px',
  }}>
    {`${moment(time).format('DD MMM YYYY')} | ${moment(time).format('hh:mmA')}`}
  </span>;
};
const Organisation = ({
  organisation,
  createdFromEmail,
}) => {
  return <div style={{
    gridArea: 'org',
  }}>
    <span style={{
      fontSize: '12px',
      color: '#888888',
      marginLeft: '3px',
    }}>
      {organisation}
    </span>
  </div>;
};
const CommentContent = ({
  // isAttachment,
  rawHtml,
  userList,
  createdFromEmail,
}) => {
  return <div
    style={{
      gridArea: 'content',
      backgroundColor: createdFromEmail ? '#80808017' : '0',
      padding: createdFromEmail ? '9px' : '0',
      marginTop: '10px',
      marginBottom: '20px',
    }}>
    <span style={{ fontSize: '14px' }}>
      {/**
        ReactHtmlParser creates jsx from html, avoids dangerouslysetinnerhtml.
        Also, each html node can be replaced with desired jsx component using 'transform()'.
      */}
      {parseMention({
        html: rawHtml,
        renderNode: (userId) => {
          const user = userList && userList.find(user => user.id === userId);
          return user ? <span style={{ color: '#1890FF' }}>
            <User user={user} />
          </span> : undefined;
        },
      })}
    </span>
  </div>;
};
const CommentCard = ({
  classes,
  data,
  userList,
  // isAttachment,
}) => {
  return <div className={classes.commentCard}>
    <Dot />
    {data.createdFromEmail && <MailIcon />}
    <div style={{ gridArea: 'creation' }}>
      <Author user={data.userDetails} />
      <Timestamp time={data.updatedAt} />
    </div>
    <Organisation
      createdFromEmail={data.createdFromEmail}
      organisation={data.organisationName} />
    <CommentContent
      // isAttachment={isAttachment}
      createdFromEmail={data.createdFromEmail}
      rawHtml={data.rawHtml}
      userList={userList} />
  </div>;
};

export default injectSheet(styles)(CommentCard);
